import React from 'react';
import Chat from '../assets/images/chaticon.svg';

export default () => {
  return <img src={Chat} alt="" />;
};
